/**
 * EliorGroup.Joyfood.B2B API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { B2BShopServiceDto } from './shopServiceDto';
import { B2BHubDto } from './hubDto';
import { B2BShopClosingDateDto } from './shopClosingDateDto';


export interface B2BCompanyShopsDto { 
    id?: number;
    name?: string | null;
    description?: string | null;
    imageUrl?: string | null;
    addressLine1?: string | null;
    addressLine2?: string | null;
    addressZipCode?: string | null;
    addressCity?: string | null;
    enShortName?: string | null;
    hubId?: number | null;
    trayLimit?: number;
    orderPlacementRange?: number;
    deliveryLocationEnabled?: boolean | null;
    mealAtPlaceEnabled?: boolean | null;
    mealAtPlaceDeliveryFromTime?: string | null;
    mealAtPlaceDeliveryToTime?: string | null;
    timeSlotDuration?: number | null;
    mealAtPlaceLocations?: string | null;
    notesEnabled?: boolean;
    canteenTimeSlotsEnabled?: boolean;
    hub?: B2BHubDto;
    shopServices?: Array<B2BShopServiceDto> | null;
    shopClosingDates?: Array<B2BShopClosingDateDto> | null;
}

